import type {
  DataResponse,
  Notification,
  NotificationPreference,
  PaginatedResponse,
  UnreadCountResponse,
} from "@/types";
import { api } from "../api";

export const notificationService = {
  list: (params?: { page?: number; pageSize?: number; unreadOnly?: boolean; type?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.pageSize) searchParams.set("page_size", String(params.pageSize));
    if (params?.unreadOnly) searchParams.set("unreadOnly", "true");
    if (params?.type) searchParams.set("type", params.type);
    return api.get<PaginatedResponse<Notification>>(`/notifications?${searchParams}`);
  },

  getUnreadCount: () => api.get<DataResponse<UnreadCountResponse>>("/notifications/unread-count"),

  markRead: (uuid: string) => api.patch<{ message: string }>(`/notifications/${uuid}/read`),

  markAllRead: () => api.post<{ message: string }>("/notifications/mark-all-read"),

  delete: (uuid: string) => api.delete<{ message: string }>(`/notifications/${uuid}`),

  getPreferences: () => api.get<DataResponse<NotificationPreference[]>>("/notifications/preferences"),

  updatePreferences: (preferences: Partial<NotificationPreference>[]) =>
    api.put<DataResponse<NotificationPreference[]>>("/notifications/preferences", { preferences }),

  /** Connect to the SSE notification stream. Returns an abort handle. */
  stream: (onEvent: (event: string, data: unknown) => void, onError?: (error: unknown) => void) =>
    api.streamGet("/notifications/stream", onEvent, onError),
};
